
import api from "./api";

const StockInfoService = {



  create: async (data) => {
    const response = await api.post("/stockInfo/save", data);
    return response.data;
  },
  getAll: async (page, limit) => {
    const response = await api.get("/stockInfo/getAll", {
      params: {
        page,
        limit
      }
    });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/stockInfo/getById/${id}`);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/stockInfo/update/${id}`, data);
    return response.data;
  },

  updateStatus: async (id, updatedBy) => {
    const response = await api.put(
      `/stockInfo/updateStatus/${id}`,
      { updatedBy }
    );
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/stockInfo/delete/${id}`);
    return response.data;
  },

  getItemStockDetails: async (storeId, itemId) => {
    const response = await api.get(
      `/stockInfo/item-stock/${storeId}/${itemId}`
    );
    return response.data;
  },


  getStoresByProject: async (projectId) => {
    const response = await api.get(
      `/stockInfo/project/${projectId}/stores`
    );
    return response.data;
  },


  getItemsByStore: async (storeId) => {
    const response = await api.get(
      `/stockInfo/store/${storeId}/items`
    );
    return response.data;
  },


  getItemStockDetails: async (storeId, itemId) => {
    const response = await api.get(
      `/stockInfo/store/${storeId}/item/${itemId}/details`
    );
    return response.data;
  },


  // 1. Company → Items
  getItemsByCompany: async (companyId, employeeId, roleId) => {
    const res = await api.get(`/stockInfo/items/${companyId || "all"}`, {
      params: { employeeId, roleId }
    });
    return res.data;
  },

  // 1b. Company → Stores
  getStoresByCompany: async (companyId, employeeId, roleId) => {
    const res = await api.get(`/stockInfo/stores/company/${companyId || "all"}`, {
      params: { employeeId, roleId }
    });
    return res.data;
  },

  // 1c. Company → Item Categories
  getItemCategoriesByCompany: async (companyId, employeeId, roleId) => {
    const res = await api.get(`/stockInfo/categories/${companyId || "all"}`, {
      params: { employeeId, roleId }
    });
    return res.data;
  },

  // 0. Company → Projects
  getProjectsByCompany: async (companyId, employeeId, roleId) => {
    const res = await api.get(
      `/stockInfo/company/${companyId || "all"}/projects`,
      { params: { employeeId, roleId } }
    );
    return res.data;
  },

  // 2. Item → Stores
  getStoresByItem: async (data) => {
    const res = await api.post(`/stockInfo/stores`, data);
    return res.data;
  },

  // 3. Store → Projects
  getProjectsByItemAndStore: async (data) => {
    const res = await api.post(`/stockInfo/projects`, data);
    return res.data;
  },

  // 4. MAIN TABLE API
  getStockList: async (data) => {
    const res = await api.post(`/stockInfo/list`, data);
    return res.data;
  }



};

export default StockInfoService;
